import Strapi from 'strapi-sdk-js';
import { config } from '../../lib';

export const strapiClient = new Strapi({
    url: config.strapiUrl,
    prefix: config.strapiPrefix,
    // store: {
    //     key: 'strapi_jwt',
    //     useLocalStorage: false,
    //     cookieOptions: { path: '/' },
    // },
    axiosOptions: {},
});
